import { DialogInfo } from "@microsoft/teams-js";
import { CardHelper, WarningCard } from "@teams/cards";
import { TeamsApplicationTypes } from "@teams/types";

import { startTask } from "./startTaskWrapper";

export const startTaskErrorMessage = (message: string, applicationType: TeamsApplicationTypes) => {
  const errorCard = WarningCard(message, applicationType);
  const taskInfo: DialogInfo = {
    card: CardHelper.toJSONv12String(errorCard),
    title: "Error",
    width: 600,
  };
  startTask(taskInfo);
};
